var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defaultTheme } from '@hn-ui/themes';
var theme = __assign(__assign({}, defaultTheme), { colors: __assign(__assign({}, defaultTheme.colors), { primary: '#42ABE9', primaryDark: '#2a6496', primaryHover: '#1786C7', primaryLight: '#ABE0FF', primaryLightest: '#F3FAFF', blackLink: '#242527', blackText: '#242527', greyText: '#777B8B', white: '#FFFFFF', yellow: '#FFC500', accentLight: '#FDECEE', blue: '#100CCA', orange: '#FF96C2', lightGrey: '#D7DDE4', lightestGrey: '#F0F2F5', lightBlue: '#02B2EE', darkBlue: '#1A95DE', darkestBlue: '#030093', disabled: '#9096AA', orange50: '#FFA51B' }) });
export default theme;
